var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-outline-primary",on:{"click":function($event){return _vm.goBack()}}},[_c('ChevronLeft'),_vm._v(" Back ")],1),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }